import clsx from 'clsx';
import s from './CustomArrowWrapper.module.scss';
interface ArrowProps {
  children?: JSX.Element;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
  focus?: boolean;
}

function CustomArrowWrapper(props: ArrowProps) {
  const { children, className, onClick, hover = true, focus } = props;
  if (!onClick) {
    return null;
  }

  return (
    <button
      tabIndex={0}
      data-hook="carousel-arrow"
      className={clsx(className, s.carouselArrow)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.();
      }}
      style={{
        opacity: hover || focus ? 1 : 0,
      }}
      aria-label="Navigate carousel"
    >
      {children}
    </button>
  );
}

export default CustomArrowWrapper;
